export interface HomeGpuPricingEntry {
  id: string;
  displayName: string;
  securePrice: number;
  communityPrice: number | null;
  memoryInGb: number | null;
  enable: boolean;
}

const API_BASE_URL = import.meta.env.VITE_API_URL || '';

export async function fetchHomeGpuPricing(): Promise<HomeGpuPricingEntry[]> {
  const response = await fetch(`${API_BASE_URL}/api/pricing/gpu-pricing`);
  const data = await response.json();
  if (data?.code !== 0) {
    throw new Error(data?.msg || 'Failed to fetch home GPU pricing');
  }

  return (data.data?.gpus || []) as HomeGpuPricingEntry[];
}